<template>
  <span>
    <div v-show="clientProfile && isFilled(clientProfile.about)">
      <b>О компании:</b>
      <span v-html="clientProfile.about"></span>
    </div>
    <div v-show="clientProfile && isFilled(clientProfile.website)">
      <b>Сайт:</b> <a :href="clientProfile.website">{{clientProfile.website}}</a>
    </div>
    <div v-show="clientProfile && isFilled(clientProfile.contacts)">
      <b>Контакты:</b>
      <span v-html="clientProfile.contacts"></span>
    </div>
    <div v-show="clientProfile && isFilled(clientProfile.services)">
      <b>Товары и услуги:</b>
      <span v-html="clientProfile.services"></span>
    </div>
    <div v-show="clientProfile && isFilled(clientProfile.price)">
      <b>Цены:</b>
      <span v-html="clientProfile.price"></span>
    </div>
    <div v-show="clientProfile && isFilled(clientProfile.docs)">
      <b>Публичные документы:</b>
      <span v-html="clientProfile.docs"></span>
    </div>
    <div v-show="clientProfile && isFilled(clientProfile.tags)">
      <b>Поисковые Теги:</b>
      <span v-html="clientProfile.tags"></span>
    </div>
    <div v-show="clientProfile && isFilled(clientProfile.other)">
      <b>Разное:</b>
      <span v-html="clientProfile.other"></span>
    </div>
  </span>
</template>

<script>
  export default {
    name: 'client-preview',
    props: {
      clientProfile: {
        type: Object,
        default: {
          website: '',
          about: '',
          contacts: '',
          services: '',
          price: '',
          docs: '',
          tags: '',
          other: ''
        }
      }
    },
    methods: {
      isFilled (value) {
        return value && value.length > 0
      }
    }

  }
</script>



// WEBPACK FOOTER //
// ClientPreview.vue?31da3cba